// extracted by mini-css-extract-plugin
export default {"refreshIcon":"ButtonResetImageEffects_refreshIcon__EqkY6"};